import { useContext } from 'react';
import { PortalAuthContext, PortalAuthContextType } from './portalAuth.context';

export const usePortalAuthContext = (): PortalAuthContextType => {
  const portalAuth = useContext(PortalAuthContext);

  if (!portalAuth) throw new Error('usePortalAuthContext is used outside of context');

  return portalAuth;
};
